import React, { RefObject } from 'react'
import { Box } from '@chakra-ui/react'

import { ErrorMessage } from 'components/form/ErrorMessage/styles'
import { VisuallyHiddenLabel } from 'components/form/VisuallyHiddenLabel/styles'

import { StyledInput, StyledTextarea } from './styles'

type Props = {
  placeholder?: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement> | any, value?: any) => void
  name: string
  onBlur?: (e: any) => void
  touched?: boolean | undefined
  error?: string | undefined
  type?: string
  label?: string
  adornmentRight?: React.ReactNode
  adornmentLeft?: React.ReactNode
  paddingLeft?: string
  paddingRight?: string
  inputRef?: RefObject<HTMLInputElement | null>
  isSmaller?: boolean
  disabled?: boolean
  className?: string
  autoComplete?: string
  integersOnly?: boolean
}

export const Input: React.FC<Props> = ({
  placeholder,
  value,
  onChange,
  name,
  onBlur,
  touched,
  error,
  type = 'text',
  label,
  adornmentRight,
  adornmentLeft,
  paddingLeft = '1rem',
  paddingRight = '1rem',
  inputRef,
  isSmaller = false,
  disabled,
  className,
  autoComplete,
  integersOnly,
}) => {
  const onKeyPress = (e: React.KeyboardEvent<any> | React.KeyboardEvent<HTMLInputElement>) => {
    if (type !== 'number') {
      return true
    }

    if (!integersOnly) {
      return true
    }

    const reg = /^\d+$/
    if (!reg.test(e.key)) {
      e.preventDefault()
      return false
    }

    return true
  }

  return (
    <>
      <VisuallyHiddenLabel htmlFor={name}>{label ?? ''}</VisuallyHiddenLabel>
      {type === 'textarea' ? (
        <StyledTextarea
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          name={name}
          onBlur={onBlur}
          isError={!!(touched && error)}
          disabled={disabled}
          data-hj-allow
        />
      ) : (
        <Box position="relative" width="100%">
          {adornmentLeft && (
            <Box
              position="absolute"
              left="1rem"
              top="50%"
              transform="translateY(-50%)"
              zIndex="docked"
              fontSize="sm"
              color="green.a200"
            >
              {adornmentLeft}
            </Box>
          )}
          <StyledInput
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            name={name}
            onBlur={onBlur}
            isError={!!(touched && error)}
            type={type}
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            ref={inputRef}
            isSmaller={isSmaller}
            disabled={disabled}
            data-hj-allow
            className={className}
            autoComplete={autoComplete}
            onWheel={(e) => (e.target as HTMLElement).blur()}
            onKeyPress={onKeyPress}
            width="100%"
          />
          {adornmentRight && (
            <Box
              position="absolute"
              right="1rem"
              top="50%"
              transform="translateY(-50%)"
              zIndex="docked"
              fontSize="sm"
              color="green.a200"
            >
              {adornmentRight}
            </Box>
          )}
        </Box>
      )}

      {touched && error && <ErrorMessage>{touched ? error : ''}</ErrorMessage>}
    </>
  )
}
